<template>
  <div class="content" :class="classContents">
    <v-card flat :class="classContents">
      <v-card-text>
        <h3>{{ $t('common.under.construction') }}</h3>
        <!--h3 v-html="helpHtml"></h3-->
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
// BEGIN::Added.by.KWShin.2022.09.16.
import axios from 'axios';

const baseURL = (() => {
  const url = new URL(location.href);
  return `${url.protocol}//${url.host}/`;
})();

const htmlGetter = axios.create({ baseURL });
// FINISH::Added.by.KWShin.2022.09.16.

export default {
  // BEGIN::Added.by.KWShin.2022.09.16.
  data() {
    return {
      helpHtml: '',
    };
  },
  // FINISH::Added.by.KWShin.2022.09.16.
  computed: {
    classContents() {
      return {
        'contents-background-dark': this.$vuetify.theme.isDark,
      };
    },
  },
  // BEGIN::Added.by.KWShin.2022.09.16.
  mounted() {
    // help.htm 파일을 로드하여 도움말 화면에 표시하는 기능.
    // helo.htm 파일 수정을 마칠때까지 일단 적용하지 않는다.
    //this.loader('/help.htm');
  },
  methods: {
    loader(path) {
      htmlGetter
        .get(path)
        .then(response => {
          this.helpHtml = response.data;
        })
        .catch(error => {
          alert(error.response.data.message);
        });
    },
  },
  // FINISH::Added.by.KWShin.2022.09.16.
};
</script>

<style lang="scss" scoped>
.content {
  width: 100%;
  height: 596px;
}
</style>
